import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
	return (
		<div className="flex h-screen bg-gray-50 relative">
			{/* Sidebar */}
			<Sidebar />

			{/* Main Section */}
			<div className="flex-1 flex flex-col">
				<Header />

				<main className="flex-1 overflow-y-auto px-6 pb-6">
					<Outlet />
				</main>

				<Footer />
			</div>
		</div>
	);
};

export default DashboardLayout;

// import React, { useState, useRef } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "../Sidebar/Sidebar";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";

// const Heart = ({ x, y }) => (
//     <span
//         style={{
//             position: "fixed",
//             left: x,
//             top: y,
//             fontSize: "16px",
//             animation: "heartFloat 0.9s ease-out forwards",
//             pointerEvents: "none",
//             zIndex: 9999,
//         }}
//     >
//         ❤️
//     </span>
// );

// const DashboardLayout = () => {
//     const [hearts, setHearts] = useState([]);
//     const lastTimeRef = useRef(0);
//     const lastPosRef = useRef({ x: 0, y: 0 });

//     const handleMouseMove = (e) => {
//         const now = performance.now();

//         if (now - lastTimeRef.current < 120) return;

//         const dx = e.clientX - lastPosRef.current.x;
//         const dy = e.clientY - lastPosRef.current.y;
//         if (Math.sqrt(dx * dx + dy * dy) < 20) return;

//         lastTimeRef.current = now;
//         lastPosRef.current = { x: e.clientX, y: e.clientY };

//         const id = now;

//         setHearts((prev) => [...prev, { id, x: e.clientX, y: e.clientY }]);

//         setTimeout(() => {
//             setHearts((prev) => prev.filter((h) => h.id !== id));
//         }, 900);
//     };

//     return (
//         <>
//             <style>{`
//                 @keyframes heartFloat {
//                     0% {
//                         transform: scale(0.6);
//                         opacity: 0.9;
//                     }
//                     100% {
//                         transform: scale(1.2) translateY(-30px);
//                         opacity: 0;
//                     }
//                 }
//             `}</style>

//             <div
//                 className="flex h-screen bg-gray-50 relative"
//                 onMouseMove={handleMouseMove}
//             >
//                 {/* ❤️ Smooth Hearts */}
//                 {hearts.map((h) => (
//                     <Heart key={h.id} x={h.x} y={h.y} />
//                 ))}

//                 <Sidebar />

//                 <div className="flex-1 flex flex-col">
//                     <Header />
//                     <main className="flex-1 overflow-y-auto px-6 pb-6">
//                         <Outlet />
//                     </main>
//                     <Footer />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default DashboardLayout;
